import { WSAlertTheme, WSIconName } from "@wingspanhq/fe-component-library";
import { IFormNote } from "../types";

export const noteTheme = (level: IFormNote["level"]): WSAlertTheme => {
  if (level === "warning") return "warning";
  // Info-level notes use the neutral (gray) alert treatment — matches the
  // design's gray "Note:" boxes while still carrying a dismiss affordance.
  return "neutral";
};

export const noteIcon = (level: IFormNote["level"]): WSIconName => {
  if (level === "warning") return "alert";
  return "info-circle";
};
